import { render, staticRenderFns } from "./FormHeaderButtons.vue?vue&type=template&id=c69a2bd8&"
import script from "./FormHeaderButtons.vue?vue&type=script&lang=js&"
export * from "./FormHeaderButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports